import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function Guarantee() {
  return <section className="bg-paper-soft px-5 py-20 lg:px-8" aria-labelledby="garantia" data-id="element-104" data-mp="1o2vfqkp72f4g">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-105" data-mp="222dadgp68mlq">
        <ShieldCheckIcon className="mx-auto h-10 w-10 text-grass" aria-hidden="true" data-id="element-106" data-mp="1x4bsgz3hetbu" />
        <h2 id="garantia" className="display mt-5 text-3xl text-ink sm:text-4xl" data-id="element-107" data-mp="1x28vfv3wvzxm">
          Garantía de "cancha libre"
        </h2>
        <p className="mt-5 text-lg leading-relaxed text-ink-soft" data-id="element-108" data-mp="14g67cb8in2bh">
          Si en 7 días abrís el material y sentís que no es para vos, o que no te
          sirve para tus entrenamientos, me mandás un WhatsApp y te devuelvo el 100%
          de la plata. Sin preguntas. Seguimos siendo amigos de fútbol.
        </p>
      </Reveal>
    </section>;
}